import * as React from 'react';

import { sections } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';

import { SectionContentLinkListIdSix } from 'components/section-content-link-list';
import { TitleAnchor } from 'components/title-anchor';
import { FormattedText, P1 } from 'components/typography';

const setTitleElement = (id: SectionContentLinkListIdSix) => {
  const mapTitleAnchorToSectionId: {
    [key in SectionContentLinkListIdSix]: {
      id: SectionContentLinkListIdSix;
      title: string;
    };
  } = {
    [SectionContentLinkListIdSix.WhatHappensWhenYouDeleteYourAccount]: {
      id: SectionContentLinkListIdSix.WhatHappensWhenYouDeleteYourAccount,
      title: sections.tabSixSection.subsection2.title(),
    },

    [SectionContentLinkListIdSix.ConnectingYouAroundTheWorld]: {
      id: SectionContentLinkListIdSix.ConnectingYouAroundTheWorld,
      title: sections.tabSixSection.subsection3.title(),
    },
  };
  return <TitleAnchor {...mapTitleAnchorToSectionId[id]} />;
};

export const getPropsSectionSixContainer = () => {
  /**
   * @todo: add real text
   */
  return {
    sections: {
      one: {
        text1: (
          <FormattedText>
            <P1 html={sections.tabSixSection.subsection1.text1()} as="p" />
          </FormattedText>
        ),
        text2: (
          <FormattedText>
            <ul>
              <li>
                <P1 html={sections.tabSixSection.subsection1.text2()} as="span" />
              </li>
            </ul>
          </FormattedText>
        ),
        text3: (
          <FormattedText>
            <ul>
              <li>
                <P1 html={sections.tabSixSection.subsection1.text3()} as="span" />
              </li>
            </ul>
          </FormattedText>
        ),
      },
      two: {
        titleElement: setTitleElement(
          SectionContentLinkListIdSix.WhatHappensWhenYouDeleteYourAccount,
        ),
        text: sections.tabSixSection.subsection2.text(),

        imageSrc: `${CdnImagePath}/landing/assets/photos/landing-section-1-Good-to-know.png`,
        imageAlt: '',
        imageObjectPosition: 'top center',
        goodToKnow: {
          title: sections.tabSixSection.subsection2.goodToKnow.title(),
          text: (
            <FormattedText>
              <P1 as="p">{sections.tabSixSection.subsection2.goodToKnow.content1()}</P1>
              <P1 as="div">{sections.tabSixSection.subsection2.goodToKnow.content2()}</P1>
            </FormattedText>
          ),
        },
        example: {
          title: sections.tabSixSection.subsection2.example.title(),
          content: sections.tabSixSection.subsection2.example.content(),
        },
        exampleRight: {
          text: (
            <FormattedText>
              <P1 as="p">{sections.tabSixSection.subsection2.exampleRight.content1()}</P1>
              <P1 html={sections.tabSixSection.subsection2.exampleRight.content2()} as="div" />
            </FormattedText>
          ),
        },
      },
      three: {
        titleElement: setTitleElement(SectionContentLinkListIdSix.ConnectingYouAroundTheWorld),
        text: (
          <FormattedText>
            <P1 html={sections.tabSixSection.subsection3.content1()} as="p" />
            <P1 html={sections.tabSixSection.subsection3.content2()} as="div" />
            <P1 html={sections.tabSixSection.subsection3.content3()} as="p" />
          </FormattedText>
        ),
      },
    },
  };
};
